import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { isEmpty, isNil } from 'ramda';

import AdministrationPage from '../containers/AdministrationPage';
import CategoryForm from './CategoryForm';

const AdminCategoryPage = (props) => {
  const id = props.params.id;
  const isEditMode = !isNil(id) && !isEmpty(id);
  
  useEffect(() => {
    if (isEditMode && !props.category) {
      props.getCategory(props.params.id);
    }
  });

  const handleSubmit = (values) => {
    if (isEditMode) {
      props.updateCategory(id, values);
    } else {
      props.createCategory(values);
    }
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>
          { isEditMode ? ((props.category && props.category.name) || 'Caricamento...') : 'Nuova categoria' } - Smart Gaming
        </title>
      </Helmet>
      <AdministrationPage>
        <CategoryForm
          loading={props.loading}
          title={ isEditMode ? 'Modifica categoria' : 'Nuova categoria' }
          initialValues={isEditMode ? props.category : null } 
          onSubmit={handleSubmit} />
      </AdministrationPage>
    </React.Fragment>
  );
};

export default AdminCategoryPage;
